import * as React from "react";
import { MessageCircleQuestionMark } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "Quais serviços a ITC+ oferece?",
  answer: "Oferecemos uma solução completa para o seu posicionamento digital: produção de vídeos corporativos estratégicos, gravação profissional em nosso estúdio de podcast e gestão de tráfego pago para maximizar a aquisição de clientes."
}, {
  question: "Onde o estúdio está localizado?",
  answer: "Nosso estúdio possui infraestrutura de ponta e está estrategicamente localizado na região de Pinheiros e Faria Lima, em São Paulo, oferecendo fácil acesso e conforto para você e seus convidados."
}, {
  question: "Vocês atendem empresas de fora de São Paulo?",
  answer: "Sim. Embora nosso estúdio físico para gravações presenciais esteja em São Paulo, realizamos a gestão de tráfego pago e consultorias de posicionamento para empresas de todo o Brasil, adaptando nossas estratégias à sua região."
}, {
  question: "Como funciona o início de um projeto com a produtora?",
  answer: "Tudo começa com uma reunião de alinhamento para entendermos seus objetivos de negócio. A partir daí, elaboramos um planejamento estratégico, definimos os formatos ideais (vídeo, podcast ou campanhas) e iniciamos a execução com foco em conversão."
}, {
  question: "Como acompanho os resultados das campanhas de tráfego?",
  answer: "A transparência é fundamental. Fornecemos relatórios detalhados de performance e realizamos reuniões periódicas de alinhamento. Nossa equipe monitora as campanhas continuamente para otimizar o seu investimento e garantir o melhor ROI."
}];
export default function FaqAccordion() {
  return <section id="faqaccordion" className="bg-background py-24 sm:py-32 section">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center justify-center p-3 bg-primary/10 rounded-full mb-6">
            <MessageCircleQuestionMark className="w-6 h-6 text-primary" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground mb-4 tracking-tight">
            Perguntas Frequentes
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Tire suas dúvidas sobre nossa infraestrutura, processos de produção e como ajudamos a escalar o seu negócio.
          </p>
        </div>

        <div className="bg-card border border-border rounded-2xl p-4 md:p-8 shadow-sm">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border">
                <AccordionTrigger className="text-left text-base md:text-lg font-default text-foreground hover:text-primary transition-colors py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}